export default __webpack_public_path__ + "static/media/go.3afe68a6.svg";